module.exports = __webpack_public_path__ + "static/kitle-dogrudan-3528eafe87eb213d210e3e3c6dcc328c.webp";